import { Component, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { Card } from '../../app/models/Card';
import { HttpErrorResponse } from '@angular/common/http';
import { CardStatement } from '../../app/models/CardStatement';
import { CardMaskPipe } from '../../app/utilities/CardMaskPipe';

@Component({
  selector: 'page-print-card',
  templateUrl: 'print-card.html',
})
export class PrintCardPage implements AfterViewInit, OnDestroy, OnInit {
  private pageName: string = 'page-print-card';

  private cardUuid: string;
  private currentCard = new Card();
  private currentStatement = new CardStatement();
  private date = new Date();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService
  ) {
    this.cardUuid = navParams.get('cardUuid');
  }

  ngOnInit(): void {}
  ngAfterViewInit(): void {}
  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.loadCardStatement();
  }

  private loadCardStatement() {
    this.backendService.getCardStatements(this.cardUuid).subscribe(
      (statement: CardStatement) => {
        this.currentStatement = statement;
        this.currentCard = statement.card;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  getPdf() {
    this.backendService.getCardStatementPdf(this.cardUuid).subscribe(
      (blob: Blob) => {
        const element = document.createElement('a');
        element.href = URL.createObjectURL(blob);
        element.download = this.currentCard.name + ' ' + new Date().toDateString() + '.pdf';
        document.body.appendChild(element);
        element.click();
      },
      (err: HttpErrorResponse) => {}
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/print-card/print-card.ts